<template>
  <v-col>
    <!-- Gallery data table -->
    <gallery-table
      :key="index"
      no-search
      url-api="/gallery"
      :headers="headers"
    >
      <!-- New new bill -->
      <template v-slot:urlCreate="{ item }">
        <v-card outlined>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-file-input
                  v-model="upload"
                  label="Select File"
                  placeholder="Upload Logo"
                  :error-messages="errors.getMessage('logo')"
                  accept="image/jpg, image/png, image/jpeg"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                sm="12"
              >
                <v-text-field
                  v-model="title"
                  label="Title"
                  :error-messages="errors.getMessage('title')"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="12"
              >
                <v-btn
                  :disabled="!title || !upload"
                  @click="createNew"
                >
                  Create
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
      <!-- end -->

      <!-- Image -->
      <template v-slot:image="{ item }">
        <v-list-item-avatar>
          <v-img
            :src="'/storage/' + item.image"
            lazy-src="/storage/default_img/no_image.png"
            aspect-ratio="1"
            max-width="65"
            max-height="65"
          />
        </v-list-item-avatar>
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- Gallery Item remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="warningItemRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </gallery-table>

    <!-- end data table -->

    <!-- Remove warning -->
    <v-dialog
      v-model="ItemRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="ItemRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeItem"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import GalleryDataTable from "../common/DataTable.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "gallery-table": GalleryDataTable,
  },
  data() {
    return {
      upload: null,
      title: "",
      item: {},
      ItemRemoveWarning: false,
      index: 1,

      headers: [
        {
          text: "Added At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "image",
          sortable: true,
          value: "image",
          slot: "image",
        },

        {
          text: "Title",
          sortable: false,
          value: "title",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    createNew() {
      if (this.upload !== null) {
        const formData = new FormData();
        formData.append("image", this.upload, this.upload.name);
        formData.append("title", this.$data.title);
        window.axios.post("/gallery", formData).then((response) => {
          if (response.data.updated) {
            this.$data.index++;
            this.$data.upload = null;
            this.$data.title = null;
            this.feedback(response.data.message);
          }
        });
      }
    },
    removeItem() {
      window.axios.delete("/gallery/" + this.$data.item.id).then((response) => {
        this.feedback(response.data.message);
        this.ItemRemoveWarning = false;
        this.$data.index++;
      });
    },

    warningItemRemove(item) {
      this.$data.item = item;
      this.ItemRemoveWarning = true;
    },
  },
};
</script>
